import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';
import image from "../../assets/forgot-password4.png";
import { useNavigate } from 'react-router-dom';
import PasswordVisibility from '../../components/Common/PasswordVisibility';
import logo from "../../assets/logo.png"

export const VerifyToken = () => {

    const params = new URLSearchParams(window.location.search);
    // Fetch the token from the query string
    const token = params.get('token');
    const navigate = useNavigate()
    useEffect(() => {

    }, [])

    const [showPassword, setShowPassword] = React.useState({
        password: false,
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const validationSchema = Yup.object({
        password: Yup.string()
            .required("Password is required")
            .min(8, "Password must be at least 8 characters"),
    });

    const formik = useFormik({
        initialValues: {
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                values.token = token

                const response = await axiosInstance.post('/users/password-recovery/confirm', values);
                console.log("verify response", response);
                if (response.status === 204) {
                    formik.resetForm();
                    toast.success("Password reseted successfully")
                    navigate("/login")
                }
            } catch (error) {
                console.error(error);
            }
        },
    });

    const [height, setHeight] = useState('100vh');

    // useEffect(() => {
    //     const updateHeight = () => {
    //         const isPortrait = window.matchMedia('(orientation: portrait)').matches;
    //         const width = window.innerWidth;

    //         // Use width < 768px as "phone"
    //         if (width < 768) {
    //             setHeight(isPortrait ? '100vh' : '100%');
    //             if (width === 720) {
    //                 setHeight('100vh')
    //             }
    //         } else {
    //             if (width === 882) {
    //                 setHeight('100%')
    //             } else {

    //                 setHeight('100vh'); // tablet and larger always 100vh
    //             }
    //         }
    //     };

    //     updateHeight(); // Run on mount

    //     window.addEventListener('resize', updateHeight);
    //     window.addEventListener('orientationchange', updateHeight);

    //     return () => {
    //         window.removeEventListener('resize', updateHeight);
    //         window.removeEventListener('orientationchange', updateHeight);
    //     };
    // }, []);

    return (
        <Box className="d-flex align-items-center justify-content-center  mx-auto login-main-wrapper"
            sx={{ height: `${height}`, padding: '20px 0px' }}>
            

            <Box
                component="form"
                onSubmit={formik.handleSubmit}
                // className='mw-100'
                className="login-wrapper"
            >
                <Box className="setting-icon mb-1" display={"flex"} justifyContent={"center"} >
                <img src={logo} alt="app-logo" loading="lazy" />
            </Box>
                <Typography variant="h5" gutterBottom className="text-center">
                    Reset Password
                </Typography>

                <TextField
                    fullWidth
                    required
                    id="password"
                    name="password"
                    type={showPassword.password ? "text" : "password"}

                    label="Password"
                    // type="password"
                    margin="normal"
                    variant="outlined"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    InputProps={{
                        endAdornment: (
                            <PasswordVisibility
                                showPassword={showPassword.password}
                                onToggle={() => togglePasswordVisibility("password")}
                            />
                        ),
                    }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    className='mt-3'
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    Submit
                </Button>
            </Box>

        </Box>
    )
}
